import $ from 'jquery';
import '@justinribeiro/lite-youtube';

$(document).ready(function() {
  openFirstFaq('.pricing-faq #bb-price-accordion');
});

$(document).on('click', '#bb-price-accordion .pricing-faq__header', function(e) {
  const target = $(e.target);
  return toggleFaq(target);
});

function openFirstFaq(id) {
  if (helpCenter()) {
    return;
  }

  const target = $(id).find('.pricing-faq__block:first-child .pricing-faq__header');
  return toggleFaq(target);
}

function toggleFaq(target) {
  const accordion = target.parents('.accordion');
  const parent = target.parents('.pricing-faq__block');
  if (parent.hasClass('open')) {
    parent.find('.pricing-faq__body').hide(500);
    parent.removeClass('open');
  } else {
    accordion.find('.pricing-faq__block .pricing-faq__body').hide(500);
    accordion.find('.pricing-faq__block').removeClass('open');
    parent.addClass('open');
    parent.find('.pricing-faq__body').show(500);
  }
  return false;
}

function helpCenter() {
  return window.location.href.indexOf('/help') > -1;
}
